import { useNavigate } from "react-router-dom";
import { ArrowRight, ClipboardList, BarChart3, BookOpen, Sparkles, Target, Lock } from "lucide-react";

export default function HowItWorks() {
  const nav = useNavigate();
  const steps = [
    { icon: ClipboardList, title: "1. Bilgilerini Bırak", desc: "Ad, soyad ve e-postanı gir. Sonuçlarını kişiselleştirip sana özel kaynakları hazırlayabilelim." },
    { icon: Target, title: "2. 50 Soruyu Yanıtla", desc: "10 yaşam alanında 5'er soru. Yaklaşık 7-10 dakika. Sorular eksiklik odaklıdır; ters skorlama ile gerçek durumun çıkar." },
    { icon: BarChart3, title: "3. Skorunu ve Radar Grafiğini Gör", desc: "Genel skorun, 10 alanın tek tek skoru ve görsel radar analizin anında hazırlanır." },
    { icon: Sparkles, title: "4. AI Destekli Kişisel Rapor", desc: "Yapay zeka, en güçlü ve gelişime açık alanlarına göre sana özel rapor üretir. Genel geçer öneri değil, sana yazılmış metin." },
    { icon: BookOpen, title: "5. Ücretsiz Kaynaklar + Kitap Önerisi", desc: "En zayıf 3 alanına göre seçilmiş ücretsiz kaynaklar ve uygun Life 101 kitabı önerilir." },
    { icon: Lock, title: "6. Verilerin Güvende", desc: "Bilgilerin yalnızca sonucunu kişiselleştirmek için kullanılır. Üçüncü taraflarla paylaşılmaz." },
  ];
  return (
    <div data-testid="how-it-works-page">
      <h1 className="text-5xl md:text-6xl font-semibold tracking-tight h-gradient">Nasıl Çalışır?</h1>
      <p className="mt-5 text-neutral-400 max-w-2xl">Life 101 Yaşam Skoru, 50 soruluk analiz ve yapay zeka destekli kişisel raporla hayatının hangi alanlarının seni geride tuttuğunu netleştirir.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-12">
        {steps.map((s, i) => (
          <div key={i} className="glass p-7 flex gap-5">
            <s.icon className="text-white shrink-0 mt-1" size={28} />
            <div>
              <h3 className="text-lg font-semibold text-white">{s.title}</h3>
              <p className="mt-2 text-neutral-400 leading-relaxed text-sm">{s.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-12 flex justify-center">
        <button onClick={() => nav("/baslayalim")} className="btn-primary inline-flex items-center gap-2" data-testid="how-start-btn">
          Şimdi Başla <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
}
